import React, { useState, useEffect, useRef } from 'react';
import { fetchColumnUniqueValues } from '../../services/api';
import './columnFilterDropdown.css';
import DropdownList from '../DropdownList/DropdownList';

const HIDDEN_DROPDOWN_FIELDS = ['chartering_datetime', 'last_order_datetime', 'updated_at'];

export default function ColumnFilterDropdown({
  data_type,
  columnName,
  columnType,
  searchParams,
  sort,
  applyFilters,
  multiSelectable,
  closeForm,
}) {
  const dropdownRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [uniqueValues, setUniqueValues] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [hasStringValues, setHasStringValues] = useState(null);

  useEffect(() => {
    const fetchUniqueValues = async () => {
      try {
        const newFilterInputs = {};
        searchParams.forEach((value, key) => {
          if (value !== '') {
            newFilterInputs[key] = value;
          }
        });
        let columnData = await fetchColumnUniqueValues(
          data_type,
          newFilterInputs,
          sort,
          columnName
        );
        columnData = columnData
          .filter(uniqueValue => uniqueValue !== null && uniqueValue !== '')
          .map(uniqueValue => ({
            value: uniqueValue,
            selected: false,
          }));
        const stringValues = columnData.filter(item => typeof item.value === 'string');
        setHasStringValues(stringValues.length > 0);
        setUniqueValues(columnData);
      } catch (error) {
        console.log(`Error fetching column ${columnName} unique values: ${error}`);
        setHasStringValues(false);
      }
    };

    if (columnName) {
      fetchUniqueValues();
    } else {
      setUniqueValues([]);
      setHasStringValues(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnName]);

  useEffect(() => {
    setFilteredValues(uniqueValues);
    if (uniqueValues.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [uniqueValues]);

  if (hasStringValues !== true || HIDDEN_DROPDOWN_FIELDS.includes(columnName)) {
    return null;
  }

  const handleClick = value => {
    if (columnType === 'boolean') {
      if (value.toLowerCase() === 'oui') {
        applyFilters([columnName, true]);
      } else if (value.toLowerCase() === 'non') {
        applyFilters([columnName, false]);
      }
    } else {
      applyFilters([columnName, value]);
    }
    closeForm();
  };

  const handleValidateSelection = () => {
    const selectedValues = filteredValues.filter(value => value.selected).map(value => value.value);
    if (multiSelectable) {
      applyFilters([columnName, selectedValues.join(',')]);
    } else {
      applyFilters([columnName, selectedValues[0]]);
    }
    closeForm();
  };

  return (
    <div ref={dropdownRef} className="column-filter-dropdown-container">
      <DropdownList
        isLoading={isLoading}
        data={filteredValues}
        setData={setFilteredValues}
        dataType={columnType}
        columnName={columnName}
        handleClick={handleClick}
        multiSelectable={multiSelectable}
        handleValidateSelection={handleValidateSelection}
      />
    </div>
  );
}
